var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('google-map',{staticClass:"relative",attrs:{"driver-list":_vm.driverList,"drivers-info":_vm.driversLocation,"name":"admiral-captains-location"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }